import LoginLayout from "./LoginLayout";
export { modes, resolveAuthOptions } from "./LoginLayout";

export default LoginLayout;